import api from "../../api";
import type {
  EvaluationAnswers,
  EvaluationApiItem,
  EvaluationData,
} from "../../../@types/portalAluno";
import {
  buildEvaluationAnswersPayload,
  mapEvaluation,
} from "../../../utils/portalAluno/mappers/evaluationMapper";

export const getEvaluation = async (idAvaliacao: number) => {
  if (!Number.isInteger(idAvaliacao) || idAvaliacao <= 0) {
    throw new Error("Avaliação inválida.");
  }

  const response = await api.get<EvaluationApiItem>("mobile/avaliacao", {
    params: { idAvaliacao },
  });

  return mapEvaluation(response.data);
};

export const submitEvaluation = async (
  evaluation: EvaluationData,
  answers: EvaluationAnswers
) => {
  await api.post(
    "mobile/respondeAvaliacao",
    buildEvaluationAnswersPayload(evaluation.questions, answers),
    { params: { idAvaliacao: evaluation.id } }
  );
};
